import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { formatDateTime } from "@redotech/redo-web/time";
import { memo, ReactNode } from "react";
import * as styles from "./flow-editor-top-header.module.css";

interface FlowEditorTopHeaderProps {
  title: string;
  publishedAt: Date | undefined | null;
  buttons: ReactNode;
}

export const FlowEditorTopHeader = memo(function FlowEditorTopHeader({
  title,
  publishedAt,
  buttons,
}: FlowEditorTopHeaderProps) {
  const isActive = !!publishedAt;

  return (
    <div className={styles.header}>
      <Flex align="center" justify="space-between" w="full">
        <Flex dir="column" gap="xs">
          <Text fontSize="lg" fontWeight="bold">
            {title}
          </Text>
          <Flex align="center" gap="sm">
            <RedoBadge
              color={isActive ? "success" : "gray"}
              size="xs"
              text={isActive ? "Active" : "Inactive"}
            />
            {publishedAt && (
              <Text color="secondary" fontSize="xs">
                Last published:{" "}
                {formatDateTime(
                  Temporal.Instant.fromEpochMilliseconds(publishedAt.getTime()),
                )}
              </Text>
            )}
          </Flex>
        </Flex>
        <Flex align="center" gap="sm">
          {buttons}
        </Flex>
      </Flex>
    </div>
  );
});
